import { render, staticRenderFns } from "./ProductRestockAlertShop.vue?vue&type=template&id=09aaad73&scoped=true"
import script from "./ProductRestockAlertShop.vue?vue&type=script&lang=js"
export * from "./ProductRestockAlertShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aaad73",
  null
  
)

export default component.exports